export default {
  label: '人力资源总监',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '人力资源总监是公司最高级别的HR职位，负责制定和实施公司整体的人力资源战略',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定公司人力资源发展规划，优化组织结构',
          id: '0-2-1',
        },
        {
          label: '构建高效能的人力资源管理体系，提升组织价值',
          id: '0-2-2',
        },
        {
          label: '负责招聘、培训、绩效考核等核心人力资源管理工作',
          id: '0-2-3',
        },
        {
          label: '推动人力资源管理落地，优化员工体验',
          id: '0-2-4',
        },
        {
          label: '参与公司战略制定，提供人力资源支持',
          id: '0-2-5',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '至少5年以上人力资源相关经验，其中3年以上高级管理经验',
          id: '0-3-1',
        },
        {
          label: '熟悉劳动法及相关法律法规',
          id: '0-3-2',
        },
        {
          label: '具备高层沟通协调能力、战略思维和商业洞察力',
          id: '0-3-3',
        },
        {
          label: '持有相关职业资格证书（如人力资源管理师证书）者优先',
          id: '0-3-4',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '35000元',
          id: '0-4-1',
        },
      ],
    }
  ],
};